import { format, parse } from 'date-fns/esm';

export const dateFormat = (v: string, viewFormat = 'dd / MM / yyyy'): string => {
  return format(parse(v, 'yyyy-MM-dd HH:mm:ss', new Date()), viewFormat);
};
